<template>
  <div class="hidden container sm:block">
    <div class="breadcrumbs z-10 flex flex-wrap items-center gap-x-3 gap-y-1 pb-3">
      <slot name="breadcrumbs" />
    </div>
  </div>
</template>
